export function generateFilters<T, K extends keyof T>(data: T[], key: K) {
  return {
    filterSearch: true,
    filters: data
      .map((record) => record[key])
      .filter(
        (record, index, self) => index === self.findIndex((p) => p === record)
      )
      // Map them to the table filters
      .map((record) => ({
        text: record,
        value: record
      })),
    onFilter: (value: any, record: any) =>
      record[key]?.includes(value as string) ?? false // Dynamic key access
  };
}
